// constants/denialReasonOptions.ts

import type { DropdownOption } from '../../../components/common/Dropdown'

const denialReasonData = [
  {
    label: 'Requested Consecutive Days Off',
    value: 'consecutive_days',
  },
  {
    label: 'Before/After Holiday',
    value: 'before_after_holiday',
  },
  {
    label: 'Staffing Needs',
    value: 'staffing_needs',
  },
  {
    label: 'Less Than 2 Weeks Notice',
    value: 'less_than_2_weeks',
  },
  {
    label: 'Too Few Hours in Bank',
    value: 'too_few_hours',
  },
  {
    label: 'Does not meet local contractual guidelines',
    value: 'contractual_guidelines',
  },
  {
    label: 'Time requested not available',
    value: 'time_not_available',
  },
  {
    label: 'Other',
    value: 'other',
  },
]

export const denialReasonOptions: DropdownOption[] = denialReasonData.map(
  (item, index) => ({
    id: String(index + 1),
    ...item,
  })
)